import Api from '@/services/Api'
import ApiTraccar from '@/services/ApiTraccar'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getAlarmConfigurations () {
   return Api().get("/alarm-configurations");
},
  updateAlarmConfiguration (params) {
    return Api().put("/alarm-configurations",params);
  },
  addAlarmConfiguration (params) {
    return Api().post("/alarm-configurations",params);
  },
  getAlarmConfiguration (params) {
    return Api().get("/alarm-configurations/"+params);
  },
  getAlarmConfigurationByRole (params) {
    return Api().get("/alarm-configurations-by-role/"+params);
  },
  getAlarmConfigurationByUser (params) {
    return Api().get("/alarm-configurations-by-user/"+params);
  },
  deleteAlarmConfiguration (params) {
    return Api().delete("/alarm-configurations/"+params);
  },
  getAlarmByImei (params) {
    return Api().post("/alarms-by-imei",params);
  },
  getAlarmEventTraccar (params) {
    return ApiTraccar().post("/events",params);
  },


}



// WEBPACK FOOTER //
// ./src/services/AlarmConfigurationService.js